'use client';

import { useState } from 'react';

import { UserToggles } from '@ravago/shared/page-data/models/config';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';

import { RequestForQuotationFlyout } from '../../dynamic-product-block/components/flyout/request-for-quotation/request-for-quotation-flyout';
import { ProductPriceCardItem } from '../models/product-price-card-item.model';

import { ProductPriceCard } from './product-price-card';

interface Props {
   productPriceCardItems: ProductPriceCardItem[];
   productDetailBaseRoute: string;
   quoteDetailBaseRoute: string | null;
   tdsAnchor: string | undefined;
   channel: string;
   showShoppingCartBtn: boolean;
   hasOrderingPermission: boolean;
   showOfflinePrices: boolean;
   showRequestQuoteOption: boolean;
   showLimitedMyPrices: boolean;
   canViewPrices: boolean;
}

export const ProductPriceListClient = ({
   productPriceCardItems,
   productDetailBaseRoute,
   quoteDetailBaseRoute,
   tdsAnchor,
   channel,
   showShoppingCartBtn,
   hasOrderingPermission,
   showOfflinePrices,
   showRequestQuoteOption,
   showLimitedMyPrices,
   canViewPrices,
}: Props) => {
   const [flyoutOpen, setFlyoutOpen] = useState(false);
   const [selectedItem, setSelectedItem] = useState<ProductPriceCardItem | undefined>(undefined);

   const handleRequestNewQuote = async (value: ProductPriceCardItem) => {
      setSelectedItem(value);
      setFlyoutOpen(true);
   };

   const userToggles: UserToggles = {
      hasGuestToggle: false,
      hasPendingToggle: false,
      hasAnonymousToggle: false,
      hasVerifiedToggle: true
   };

   const color =
      selectedItem?.colorId || selectedItem?.color
         ? {
              colorId: selectedItem?.colorId,
              colorName: selectedItem?.color || '',
              producerColorCode: selectedItem?.producerColorCode,
              desiredColor: undefined,
              projectDescription: undefined
           }
         : undefined;

   return (
      <>
         <Box direction="column" gap="sm">
            {productPriceCardItems.map((value, index) => (
               <ProductPriceCard
                  /* eslint-disable-next-line @eslint-react/no-array-index-key */
                  key={`${value.productId}-${index}`}
                  productPriceCardItemId={`${value.productId}-${index}`}
                  productPriceCardItem={value}
                  productDetailBaseRoute={productDetailBaseRoute ?? ''}
                  quoteDetailBaseRoute={quoteDetailBaseRoute}
                  tdsAnchor={tdsAnchor}
                  channel={channel}
                  isOverview={!!quoteDetailBaseRoute}
                  showShoppingCartBtn={showShoppingCartBtn}
                  hasOrderingPermission={hasOrderingPermission}
                  showOfflinePrices={showOfflinePrices}
                  showRequestQuoteOption={showRequestQuoteOption}
                  showLimitedMyPrices={showLimitedMyPrices}
                  canViewPrices={canViewPrices}
                  onRequestQuote={() => handleRequestNewQuote(value)}
               />
            ))}
         </Box>

         {selectedItem && (
            <RequestForQuotationFlyout
               key={selectedItem.productId}
               open={flyoutOpen}
               color={color}
               productId={selectedItem.productId.toString()}
               productDescription={selectedItem.description}
               isCustomerProduct
               userToggles={userToggles}
               type="QUICK_QUOTE"
               from="MY_PRICES"
               onClose={() => setFlyoutOpen(false)}
               onComplete={() => setFlyoutOpen(false)}
            />
         )}
      </>
   );
};
